export {
    validateAll,
    validateFullName,
    validatePassword,
    MAX_FULL_NAME_LENGTH_IN_CHARS,
    MAX_PASSWORD_LENGTH_IN_CHARS,
    MIN_PASSWORD_LENGTH_IN_CHARS,
} from './sign-up-form-validator';
